export default __webpack_public_path__ + "static/media/Warehouse.d1cbda05.jpg";